// Global loading state manager
// This can be used in both React components and non-React code (like axios interceptors)

class LoadingManager {
  constructor() {
    this.requestCount = 0;
    this.listeners = new Set();
  }

  // Subscribe to loading state changes
  subscribe(listener) {
    this.listeners.add(listener);
    // Immediately call with current state
    listener(this.requestCount > 0);
    
    // Return unsubscribe function
    return () => {
      this.listeners.delete(listener);
    };
  }

  // Notify all listeners of loading state change
  notify() {
    const isLoading = this.requestCount > 0;
    this.listeners.forEach(listener => listener(isLoading));
  }

  // Start loading (increment request count)
  start() {
    this.requestCount += 1;
    this.notify();
  }

  // Stop loading (decrement request count)
  stop() {
    this.requestCount = Math.max(0, this.requestCount - 1);
    this.notify();
  }

  // Get current loading state
  isLoading() {
    return this.requestCount > 0;
  }
}

// Export singleton instance
export const loadingManager = new LoadingManager();
